import React from "react";
import PageHeader from "./PageHeader";
import { cn } from "../../lib/utils";

export interface PageShellProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  stickyHeader?: boolean;
  headerClassName?: string;
  contentClassName?: string;
  stats?: React.ReactNode;
  children: React.ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({
  title,
  subtitle,
  actions,
  stickyHeader = true,
  headerClassName,
  contentClassName,
  stats,
  children,
}) => {
  return (
    <div className="min-h-screen bg-background">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={actions}
        sticky={stickyHeader}
        className={headerClassName}
      />
      <div className={cn("px-6 py-6", contentClassName)}>
        {stats ? <div className="mb-4">{stats}</div> : null}
        {children}
      </div>
    </div>
  );
};

export default PageShell;
